import { useTechnicianDocument } from '../hooks/useTechnicianDocument'
import { ReactNode } from 'react'
import { useShallow } from 'zustand/react/shallow'
import {
  NewComment,
  CommentsList,
} from '@/pages/DocumentPage/components/Documents/Comments'
import { useTechnicianPageStore } from '../hooks/useTechnicianPageStore'
import { useSidebar } from '@/components/ui/sidebar'
import { useListComments } from '@/services/queries/comments'
import { useIsReadOnly } from '@/pages/CADPage/hooks/useIsReadOnly'
import { Sheet, SheetContent } from '@/components/ui/sheet'
import { Spinner } from '@/components/ui/spinner'

export const TechnicianComments = () => {
  const commentsEnabled = useTechnicianPageStore(
    (state) => state.commentsEnabled,
  )
  const { currentPage } = useTechnicianDocument()
  const canSeeComments = currentPage && currentPage.id && !currentPage.type

  const { data: comments, isLoading: isCommentsLoading } = useListComments({
    documentPageId: canSeeComments ? currentPage.id : null,
  })

  const {
    isLoading: isLoadingReadOnlyInfo,
    data: { isUserReadOnly },
  } = useIsReadOnly()

  const isLoading = isCommentsLoading || isLoadingReadOnlyInfo

  if (!commentsEnabled) {
    return null
  }

  return (
    <MobileSheet>
      <div id="tech-comments" className="border-l h-full w-80">
        {canSeeComments && isLoading && <Spinner />}
        {canSeeComments && currentPage.id && (
          <>
            <div className="h-[calc(100vh-295px)] overflow-y-auto">
              <CommentsList
                key={currentPage.id}
                comments={comments}
                documentPageId={currentPage.id}
                canEdit={!isUserReadOnly}
              />
            </div>
            <div className="px-2 pt-2 pb-4 border-t">
              <NewComment
                key={currentPage.id}
                documentPageId={currentPage.id}
              />
            </div>
          </>
        )}
      </div>
    </MobileSheet>
  )
}

const MobileSheet = ({ children }: { children: ReactNode }) => {
  const { isMobile } = useSidebar()
  const commentsEnabled = useTechnicianPageStore(
    (state) => state.commentsEnabled,
  )
  const setCommentsEnabled = useTechnicianPageStore(
    useShallow((state) => state.setCommentsEnabled),
  )

  if (!isMobile) {
    return children
  }

  return (
    <Sheet
      open={commentsEnabled}
      onOpenChange={(isOpen) => {
        setCommentsEnabled(isOpen)
      }}
    >
      <SheetContent
        className="duration-100 h-full w-80 px-0 pt-4 flex flex-col"
        side="right"
      >
        {children}
      </SheetContent>
    </Sheet>
  )
}
